import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cagnottes',
  templateUrl: './cagnottes.component.html',
  styleUrls: ['./cagnottes.component.css']
})
export class CagnottesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
